'use es6';

import PropTypes from 'prop-types';
import { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Immutable from 'immutable';
import UIBreadcrumbs from 'UIComponents/nav/UIBreadcrumbs';
import UILink from 'UIComponents/link/UILink';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { getAncestorPaths, getLeafFolderName } from 'FileManagerCore/utils/FoldersAndFiles';
import { navigateToFolder } from '../actions/Folders';
import { getCurrentFolderAncestors, getFolderIdFromUrl, getFolderPathFromUrl } from '../selectors/FoldersAndFiles';
import UsageTracker from '../utils/usageTracker';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const rootFolderMessage = /*#__PURE__*/_jsx(FormattedMessage, {
  message: "FileManagerDashboard.app.rootFolder"
});
class Breadcrumbs extends Component {
  constructor(...args) {
    super(...args);
    this.renderSegment = ({
      name,
      path,
      folderId
    }) => {
      const {
        onNavigateToFolder
      } = this.props;
      const onClick = event => {
        event.preventDefault();
        UsageTracker.track('fileManagerExploreFiles', {
          action: 'click-header-breadcrumb'
        });
        onNavigateToFolder(folderId);
      };
      const disabled = path !== '/' && !folderId;
      return /*#__PURE__*/_jsx(UILink, {
        size: "small",
        onClick: onClick,
        disabled: disabled,
        children: name
      }, path);
    };
  }
  isBrowsingFolder() {
    return this.props.folderId || this.props.folderPath;
  }
  getPathSegments() {
    const {
      currentFolderAncestors,
      folderPath
    } = this.props;
    const segments = [{
      name: rootFolderMessage,
      path: '/'
    }];
    if (currentFolderAncestors && !currentFolderAncestors.isEmpty()) {
      return segments.concat(currentFolderAncestors.toArray().map(folder => ({
        name: folder.get('name'),
        path: folder.get('full_path'),
        folderId: folder.get('id')
      })));
    }
    if (folderPath) {
      const parts = getAncestorPaths(folderPath);
      return segments.concat(parts.map(path => ({
        path,
        name: getLeafFolderName(path)
      })));
    }
    return segments;
  }
  render() {
    const segments = this.getPathSegments();
    let last;
    if (!this.isBrowsingFolder() || segments.length > 1) {
      last = segments.pop();
    }
    return /*#__PURE__*/_jsxs(UIBreadcrumbs, {
      "data-test-id": "folder-breadcrumbs",
      className: "folder-breadcrumbs p-all-0 m-all-0",
      singleBreadcrumbIsBackLink: false,
      wrapLevels: true,
      children: [segments.map(this.renderSegment), last && /*#__PURE__*/_jsx("span", {
        className: "current",
        children: last.name
      })]
    });
  }
}
Breadcrumbs.propTypes = {
  folderPath: PropTypes.string,
  folderId: PropTypes.number,
  currentFolderAncestors: PropTypes.instanceOf(Immutable.OrderedMap),
  onNavigateToFolder: PropTypes.func.isRequired
};
const mapStateToProps = (state, props) => ({
  currentFolderAncestors: getCurrentFolderAncestors(state, props),
  folderPath: getFolderPathFromUrl(state, props),
  folderId: getFolderIdFromUrl(state, props)
});
const mapDispatchToProps = {
  onNavigateToFolder: navigateToFolder
};
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Breadcrumbs));